import React from 'react'
import {
  Highlight,
  connectStateResults,
  connectHits,
  Snippet,
} from 'react-instantsearch-dom'

import {Link} from '../Link'
import {algoliaReleases} from '../../config/site'

import './Results.scss'

function Hit({hits, downshiftProps: {getItemProps, highlightedIndex}}) {
  return (
    <ul className="hits-wrapper">
      {hits.map((hit, index) => {
        return (
          <li
            {...getItemProps({
              key: hit.objectID,
              item: hit,
              index,
              style: {
                backgroundColor:
                  highlightedIndex === index ? '#ddf4f9' : 'white',
              },
            })}
            key={hit.objectID}
            className="hit"
          >
            <div className="hit-name">
              <Link className="hit-title" hasLocale to={hit.slug}>
                <Highlight className="header" attribute="header" hit={hit} />
                <small>
                  <Highlight className="title" attribute="title" hit={hit} />
                </small>
              </Link>
            </div>
            <div className="hit-description">
              <p style={{color: '#999'}}>
                <Snippet attribute="text" hit={hit} separator="..." />
              </p>
            </div>
          </li>
        )
      })}
    </ul>
  )
}

const HitWithData = connectHits(Hit)

function FilterSearch({release: selectedRelease, setRelease}) {
  function handleChange(e) {
    setRelease(e.target.value)
  }
  return (
    <div className="filter-search">
      <h3>Releases</h3>
      <div>
        {algoliaReleases.map(release => (
          <div className="form-check" key={release}>
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="radio"
                name="release"
                value={release}
                onChange={handleChange}
                checked={release === selectedRelease}
              />
              {release}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

function Results({
  searchState,
  searchResults,
  downshiftProps,
  release,
  setRelease,
}) {
  return (
    <div className="search-results-wrapper">
      <div className="results-section">
        {searchResults && searchResults.nbHits ? (
          <div className="results-section-container">
            <FilterSearch release={release} setRelease={setRelease} />
            <HitWithData downshiftProps={downshiftProps} />
          </div>
        ) : (
          <div className="center-body">
            <p className="m-0">
              No results found for a query
              <strong>{`"${searchState.query}"`}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default connectStateResults(Results)
